export default __webpack_public_path__ + "static/media/1.b3a5b17d.jpg";